module.exports = __webpack_public_path__ + "media/assets/attachment_field-eecad3e2ded79d13c5e30e6ddfb9112f.svg";